export const NEW = "#0072CE";
export const IN_PROGRESS = "#FEC108";
export const COMPLETE = "#12941F";
export const FINISH_PRODUCT = "#02aeba";
export const MATERIAL = "#0065A2";
export const PACKAGING = "#e07b00";
export const SALE_OFF = "#FF5768";
export const ERROR = "#FF5768";
export const CANCEL = "#D1D1D1";
